/** Leaves the portal for another address, such as the issuer continuing an OAuth flow. */
export function navigate(url: string): void {
  window.location.assign(url);
}
